import { Components, Theme } from '@mui/material/styles';

import { addEvenOddRowClassName } from '@/utils/dataGridUtil';

export default function MuiDataGrid(theme: Theme): Components['MuiDataGrid'] {
  const toolbarStyles = {
    paddingBottom: '4px',
    backgroundColor: theme.palette.sandShade1.main,
    borderBottom: `1px solid ${theme.palette.sandShade2.main}`,

    '& .MuiInputBase-root': {
      borderColor: theme.palette.forest.main,
    },
    '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.forest.main,
    },
    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.forest.main,
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.forest.main,
    },
  };

  return {
    defaultProps: {
      getRowClassName: addEvenOddRowClassName(),
    },
    styleOverrides: {
      root: {
        borderRadius: '8px',
        border: `1px solid ${theme.palette.sandShade2.main}`,

        '--DataGrid-rowBorderColor': 'unset',
        '@media print': {
          width: '100vw',
        },
      },
      virtualScroller: {
        backgroundColor: theme.palette.sand.light,
      },

      columnHeader: {
        backgroundColor: theme.palette.sandShade1.main,
        fontSize: 16,
        border: 'none !important',
      },
      row: {
        border: 'none',
        boxShadow: `inset 0 -.5px 0 0 ${theme.palette.sandShade4.main}`,

        '&.odd:not(.Mui-selected):not(:hover)': {
          backgroundColor: theme.palette.sandShade1.main,
        },
      },
      cell: {
        borderColor: theme.palette.sandShade4.main,
        fontSize: 12,
      },
      columnSeparator: {
        color: theme.palette.divider,
      },
      withBorderColor: {
        border: 'none',
        borderColor: theme.palette.divider,
      },
      columnHeaders: {},
      footerContainer: {
        backgroundColor: theme.palette.sand.light,
        minHeight: '54px',
        '@media print': {
          display: 'none',
        },
      },

      toolbar: toolbarStyles,
      toolbarContainer: toolbarStyles,
      filterForm: {
        alignItems: 'end',
      },
    },
  };
}
